import React, { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { Link } from "react-router-dom"
import { Collapse } from "reactstrap"
import { getProvinceTotalExpireReceiptsCount } from "store/province-exipre-receipts/province-expire-receipts-action"
import ProtectedMenuItem from "components/Common/ProtectedMenuItem"
import { PERMISSIONS } from "utils/permissionConfig"

const ProvinceNavbar = props => {
  const [report, setReport] = useState(false)
  const [items, setItems] = useState(false)
  const [systemSetup, setSystemSetup] = useState(false)

  const dispatch = useDispatch()

  const totalExpireCount = useSelector(
    state => state.provinceExpireReceipts.count
  )

  useEffect(() => {
    dispatch(getProvinceTotalExpireReceiptsCount())
  }, [])

  return (
    <Collapse
      isOpen={props.leftMenu}
      className="navbar-collapse"
      id="topnav-menu-content"
    >
      <ul className="navbar-nav">
        <ProtectedMenuItem permission={PERMISSIONS.SHOW_PROVINCE_IN}>
          <li className="nav-item ">
            <Link className="nav-link " to="/province-receipts">
              <i className="bx bx-home-circle me-2"></i>
              Receipts ( In )
            </Link>
          </li>
        </ProtectedMenuItem>
        <ProtectedMenuItem permission={PERMISSIONS.SHOW_PROVINCE_OUT}>
          <li className="nav-item ">
            <Link className="nav-link " to="/province-distributions">
              <i className="bx bx-home-circle me-2"></i>
              Distributions ( Out )
            </Link>
          </li>
        </ProtectedMenuItem>
        <li className="nav-item ">
          <Link
            className="nav-link "
            to="/province-expire-receipts"
            style={totalExpireCount > 0 ? { color: "red" } : {}}
          >
            <i className="bx bx-home-circle me-2"></i>
            Expiry List{" "}
            <span className="text-danger" style={{ fontSize: 11 }}>
              ( {totalExpireCount} )
            </span>
          </Link>
        </li>
        <ProtectedMenuItem permission={PERMISSIONS.SHOW_CONSUMPTION}>
          <li className="nav-item ">
            <Link className="nav-link " to="/province-consumptions">
              <i className="bx bx-home-circle me-2"></i>
              Consumptions
            </Link>
          </li>
        </ProtectedMenuItem>

        <ProtectedMenuItem permission={[PERMISSIONS.SHOW_WAREHOUSE, PERMISSIONS.SHOW_PROJECT, PERMISSIONS.SHOW_PROVIDER, PERMISSIONS.SHOW_PROVINCE, PERMISSIONS.SHOW_CURRENCY, PERMISSIONS.SHOW_FACILITY, PERMISSIONS.SHOW_IP]} permissionLogic="any">
          <li className="nav-item dropdown">
            <Link
              className="nav-link dropdown-toggle arrow-none"
              onClick={e => {
                e.preventDefault()
                setSystemSetup(!systemSetup)
              }}
              to="#"
            >
              <i className="mdi mdi-cog me-2"></i>
              System Setup {props.menuOpen}
              <div className="arrow-down"></div>
            </Link>
            <div className={"dropdown-menu"}>
              <ProtectedMenuItem permission={PERMISSIONS.SHOW_WAREHOUSE}>
                <Link to="/warehouse" className="dropdown-item">
                  <i className="mdi mdi-warehouse me-2"></i>
                  Warehouse
                </Link>
              </ProtectedMenuItem>
              <ProtectedMenuItem permission={PERMISSIONS.SHOW_PROJECT}>
                <Link to="/projects" className="dropdown-item">
                  <i className="mdi mdi-order-bool-descending me-2"></i>
                  Project
                </Link>
              </ProtectedMenuItem>
              <ProtectedMenuItem permission={PERMISSIONS.SHOW_PROVIDER}>
                <Link to="/providers" className="dropdown-item">
                  <i className="mdi mdi-order-bool-descending me-2"></i>
                  Providers
                </Link>
              </ProtectedMenuItem>
              <ProtectedMenuItem permission={PERMISSIONS.SHOW_PROVINCE}>
                <Link to="/provinces" className="dropdown-item">
                  <i className="mdi mdi-google-maps me-2"></i>
                  Province
                </Link>
              </ProtectedMenuItem>
              <ProtectedMenuItem permission={PERMISSIONS.SHOW_CURRENCY}>
                <Link to="/currencies" className="dropdown-item">
                  <i className="mdi mdi-currency-usd me-2"></i>
                  Currency
                </Link>
              </ProtectedMenuItem>
              <ProtectedMenuItem permission={PERMISSIONS.SHOW_FACILITY}>
                <Link to="/facilities" className="dropdown-item">
                  <i className="mdi mdi-home me-2"></i>
                  Facilities
                </Link>
              </ProtectedMenuItem>
              <ProtectedMenuItem permission={PERMISSIONS.SHOW_IP}>
                <Link to="/ips" className="dropdown-item">
                  <i className="mdi mdi-account-group me-2"></i>
                  IPs
                </Link>
              </ProtectedMenuItem>
            </div>
          </li>
        </ProtectedMenuItem>

        <ProtectedMenuItem permission={[PERMISSIONS.SHOW_ITEM_CATEGORY, PERMISSIONS.SHOW_ITEM]} permissionLogic="any">
          <li className="nav-item dropdown">
            <Link
              className="nav-link dropdown-toggle arrow-none"
              onClick={e => {
                e.preventDefault()
                setItems(!items)
              }}
              to="#"
            >
              <i className="mdi mdi-order-bool-descending me-2"></i>
              Items {props.menuOpen}
              <div className="arrow-down"></div>
            </Link>
            <div className={"dropdown-menu"}>
              <ProtectedMenuItem permission={PERMISSIONS.SHOW_ITEM_CATEGORY}>
                <Link to="/item-categories" className="dropdown-item">
                  Item Category
                </Link>
              </ProtectedMenuItem>
              <ProtectedMenuItem permission={PERMISSIONS.SHOW_ITEM}>
                <Link to="/items" className="dropdown-item">
                  Item
                </Link>
              </ProtectedMenuItem>
            </div>
          </li>
        </ProtectedMenuItem>

        <ProtectedMenuItem permission={PERMISSIONS.SHOW_REPORT}>
          <li className="nav-item dropdown">
            <Link
              className="nav-link dropdown-toggle arrow-none"
              onClick={e => {
                e.preventDefault()
                setReport(!report)
              }}
              to="#"
            >
              <i className="mdi mdi-order-bool-descending me-2"></i>
              Reports {props.menuOpen}
              <div className="arrow-down"></div>
            </Link>
            <div className={"dropdown-menu"}>
              <Link to="/province-transactions" className="dropdown-item">
                All Transactions ( In / Out )
              </Link>
              <Link to="/province-consumptions-reports" className="dropdown-item">
                Consumptions Report
              </Link>
            </div>
          </li>
        </ProtectedMenuItem>
        <li className="nav-item ">
          <Link className="nav-link " to="/dashboard">
            <i className="bx bx-home-circle me-2"></i>
            Dashboard
          </Link>
        </li>
      </ul>
    </Collapse>
  )
}

export default ProvinceNavbar
